import { render, staticRenderFns } from "./wf-currency-entry-display.vue?vue&type=template&id=1905354c&scoped=true&"
import script from "./wf-currency-entry-display.vue?vue&type=script&lang=ts&"
export * from "./wf-currency-entry-display.vue?vue&type=script&lang=ts&"
import style0 from "./wf-currency-entry-display.vue?vue&type=style&index=0&id=1905354c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1905354c",
  null
  
)

export default component.exports